module.exports = __webpack_public_path__ + "img/partner7.212261f8.jpg";